import React from "react";
import CarNotasDetalle from './CarNotasDetalle';

const CarNotas = ({ ciclo, datos }) => {
  const notas = datos || [];
  const promedio = notas.length > 0
    ? (notas.reduce((s, n) => s + n.nota, 0) / notas.length)
    : 0;

  return (
    <div className="card">
      <div className="card-header d-flex align-items-center justify-content-between">
        <span>{ciclo}</span>
        <span className="esen-chip esen-chip--neutral">
          Promedio {promedio.toFixed(1)}
        </span>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Materia</th>
                <th scope="col" style={{ width: '32%' }}>Nota</th>
                <th scope="col">Matrícula</th>
              </tr>
            </thead>
            <tbody>
              {
                notas.map((x, i) => {
                  return (
                    <CarNotasDetalle
                      key={i}
                      materia={x.materia}
                      nota={x.nota}
                      matricula={x.matricula} />
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CarNotas;
